import { render, staticRenderFns } from "./form_course.vue?vue&type=template&id=7f36cbde&scoped=true&"
import script from "./form_course.vue?vue&type=script&lang=js&"
export * from "./form_course.vue?vue&type=script&lang=js&"
import style0 from "./form_course.vue?vue&type=style&index=0&id=7f36cbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36cbde",
  null
  
)

export default component.exports